import {useEffect, useState} from "react";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const useSse = () => {
    const [dashboardData, setDashboardData] = useState(undefined);
    const [lanesData, setLanesDate] = useState(undefined);

    useEffect(() => {
        const dashboardEventSource = new EventSource(API_KEEPER + "/analytics/dashboard");

        const lanesEventSource = new EventSource(API_KEEPER + "/analytics/dashboard/lanes/stream");

        dashboardEventSource.onmessage = event => {
            const parseData = JSON.parse(event.data);

            if (!parseData) return;

            if (parseData.type === "dashboard") {
                setDashboardData(parseData.value);
            }
        }

        lanesEventSource.onmessage = event => {
            const parseData = JSON.parse(event.data);

            if (!parseData) return;

            if (parseData.type === "lanes") {
                setLanesDate(parseData.value);
            }
        }

        dashboardEventSource.onerror = e => {
            console.error("Erro ao carregar dashboard analytics:", e);
        }

        lanesEventSource.onerror = e => {
            console.error("Erro ao carregar camêras:", e);
        }

        return () => {
            dashboardEventSource.close();
            lanesEventSource.close();
        }
    }, []);

    return { dashboardData, lanesData };
}

export default useSse;